import { FC, useCallback, useEffect, useState } from "react";

import { DigipostEntryPoint } from "../../../types/entrypoint";
import { useEntrypointContext } from "../EntrypointContext";
import { remove } from "../infrastructure/digipost-fetch";
import { useRootPath } from "../infrastructure/hooks/useRootPath";
import { findURIWithWindowHostname } from "../infrastructure/link";
import {
  getTokenApproveCode,
  getTokenObjectFromBackend,
  useTokenParam,
} from "./oauth-utils";
import SpinnerContainer from "./spinnerContainer/SpinnerContainer";

export const OAuthSuccessWithIDportenLogout: FC = () => {
  const entrypoint: DigipostEntryPoint = useEntrypointContext();
  const [asyncError, setAsyncError] = useState<Error>();
  const rootPath = useRootPath();

  const token = useTokenParam();

  if (asyncError) {
    throw asyncError;
  }

  const authorizeTokenAndLogoutOfIDporten =
    useCallback(async (): Promise<void> => {
      try {
        const tokenObject = await getTokenObjectFromBackend(token);
        const approveCode = await getTokenApproveCode(
          tokenObject,
          entrypoint.csrfToken,
        );
        const redirectUrl = `${tokenObject.redirectUri}?&state=${tokenObject.state}&code=${approveCode}`;
        window.location.href = redirectUrl;

        //Hele denne funksjonen er ment å fjernes, når gamle mobilapp-versjoner deprecates.
        //I mellomtiden må utlogging av IDPorten-sesjon håndteres ved innlogging for
        // mobilapp-versjoner som ikke kaller OAuthLogout-endepunktet ved utlogging.
        try {
          const logoutUrl = findURIWithWindowHostname(
            "logout",
            entrypoint.link,
          );

          const extraHeader = {
            FINAL_DESTINATION: `${rootPath}/mobileRedirect/${encodeURIComponent(
              redirectUrl,
            )}`,
          };

          const logoutResponse = await remove(
            logoutUrl,
            entrypoint.csrfToken,
            {},
            extraHeader,
          );

          const idPortenLogoutLocation = logoutResponse.headers.get("Location");
          if (idPortenLogoutLocation != null) {
            window.location.href = idPortenLogoutLocation;
          } else {
            window.location.href = redirectUrl;
          }
        } catch (e) {
          window.location.href = redirectUrl;
        }
      } catch (error) {
        if (typeof error === "string") {
          setAsyncError(new Error(error));
        } else if (error instanceof Error) {
          setAsyncError(error);
        } else {
          setAsyncError(
            new Error("Unknown error occurred during token approve"),
          );
        }
      }
    }, [entrypoint, token]);

  useEffect(() => {
    authorizeTokenAndLogoutOfIDporten();
  }, [authorizeTokenAndLogoutOfIDporten]);

  return <SpinnerContainer />;
};
